export function formatRelativeDate(date: Date): string {
  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
  const now = new Date();
  const diffMs = date.getTime() - now.getTime();

  // Convert to seconds, minutes, hours, days
  const seconds = Math.round(diffMs / 1000);
  const minutes = Math.round(seconds / 60);
  const hours = Math.round(minutes / 60);
  const days = Math.round(hours / 24);

  if (Math.abs(seconds) < 60) {
    return rtf.format(seconds, "second");
  } else if (Math.abs(minutes) < 60) {
    return rtf.format(minutes, "minute");
  } else if (Math.abs(hours) < 24) {
    return rtf.format(hours, "hour");
  } else {
    return rtf.format(days, "day");
  }
}
